var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateLoadStatus4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.476 11.236H.54v-.768l3.84-5.676h1.104v5.484H6.54v.96H5.484V13H4.476v-1.764zm0-.96V6.28h-.048l-2.724 3.996h2.772zm6.562-5.868h.948L8.422 13h-.948l3.564-8.592zm5.086 6.828h-3.936v-.768l3.84-5.676h1.104v5.484h1.056v.96h-1.056V13h-1.008v-1.764zm0-.96V6.28h-.048l-2.724 3.996h2.772z",
    fill: "#9390A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLoadStatus4);
export default __webpack_public_path__ + "static/media/create-load-status-4.d84f1996dfeb303660ef64ecbc21e27a.svg";
export { ForwardRef as ReactComponent };